<template>
  <div>
    <h2 class="text-center">API 본 계약 관리</h2>

    <div v-if="loadingDistributors" class="text-center text-muted py-4">
      유통사 목록을 불러오는 중입니다
    </div>
    <div v-else-if="distributorError" class="text-center text-danger py-4">
      <p>{{ distributorError }}</p>
      <button type="button" class="btn btn-secondary btn-sm" @click="loadDistributors">
        다시 시도
      </button>
    </div>
    <div v-else-if="distributors.length === 0" class="text-center text-muted py-4">
      관리 중인 API 유통사가 없습니다
    </div>
    <div v-else>
      <div class="form-group row justify-content-center">
        <label for="distributor-select" class="col-form-label mr-2">유통사</label>
        <div class="col-md-5">
          <select id="distributor-select" v-model="selectedUsername" class="form-control" @change="loadInstitutions">
            <option value="" disabled>유통사를 선택하세요</option>
            <option v-for="distributor in distributors" :key="distributor.username" :value="distributor.username">
              {{ distributor.name }} ({{ distributor.username }})
            </option>
          </select>
        </div>
      </div>

      <div v-if="!selectedUsername" class="text-center text-muted py-4">
        유통사를 선택하세요
      </div>

      <div v-if="selectedUsername">
        <div v-if="loadingInstitutions" class="text-center text-muted py-4">
          기관 요청 이력을 불러오는 중입니다
        </div>
        <div v-else-if="institutionError" class="text-center text-danger py-4">
          <p>{{ institutionError }}</p>
          <button type="button" class="btn btn-secondary btn-sm" @click="loadInstitutions">
            다시 시도
          </button>
        </div>
        <div v-else-if="institutions.length === 0" class="text-center text-muted py-4">
          이 유통사에서 발생한 X-Institution 요청 이력이 없습니다
        </div>
        <div v-else class="table-responsive-wrapper">
          <table class="table table-hover table-sm">
            <thead>
              <tr>
                <th>기관명</th>
                <th>최초 요청일</th>
                <th>최근 요청일</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in institutions" :key="item.institution">
                <td>{{ item.institution }}</td>
                <td>{{ item.first_request_date }}</td>
                <td>{{ item.last_request_date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="text-muted small">
          기관명은 API에서 전송된 그대로 표시되며, 대소문자 또는 공백 차이는 별도 행으로 표시됩니다. 날짜는 KST 기준입니다.
          삭제된 건과 실패한 요청도 포함된 <strong>요청 이력</strong>이므로 과금 집계와는 다를 수 있습니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/libs/axios";

export default {
  name: "ApiUnlimitedInstitutions",
  data: function() {
    return {
      distributors: [],
      institutions: [],
      selectedUsername: "",
      loadingDistributors: false,
      loadingInstitutions: false,
      distributorError: "",
      institutionError: "",
      institutionRequestSeq: 0
    };
  },
  methods: {
    loadDistributors: function() {
      this.loadingDistributors = true;
      this.distributorError = "";
      return axios.get("/api/admin/api-unlimited-institutions/distributors")
        .then(function(response) {
          if (!response.data.success) {
            throw new Error(response.data.message || "유통사 목록을 불러올 수 없습니다");
          }
          this.distributors = response.data.distributors || [];
          if (this.distributors.length === 1) {
            this.selectedUsername = this.distributors[0].username;
            this.loadInstitutions();
          }
        }.bind(this))
        .catch(function(error) {
          this.distributorError = (error.response && error.response.data && error.response.data.message) || error.message || "유통사 목록을 불러올 수 없습니다";
        }.bind(this))
        .then(function() {
          this.loadingDistributors = false;
        }.bind(this));
    },
    loadInstitutions: function() {
      if (!this.selectedUsername) return Promise.resolve();
      var requestSeq = ++this.institutionRequestSeq;
      var username = this.selectedUsername;
      this.loadingInstitutions = true;
      this.institutionError = "";
      this.institutions = [];
      return axios.get("/api/admin/api-unlimited-institutions", {
        params: { owner_username: username }
      })
        .then(function(response) {
          if (requestSeq !== this.institutionRequestSeq) return;
          if (!response.data.success) {
            throw new Error(response.data.message || "기관 요청 이력을 불러올 수 없습니다");
          }
          this.institutions = response.data.institutions || [];
        }.bind(this))
        .catch(function(error) {
          if (requestSeq !== this.institutionRequestSeq) return;
          this.institutionError = (error.response && error.response.data && error.response.data.message) || error.message || "기관 요청 이력을 불러올 수 없습니다";
        }.bind(this))
        .then(function() {
          if (requestSeq === this.institutionRequestSeq) {
            this.loadingInstitutions = false;
          }
        }.bind(this));
    }
  },
  created: function() {
    this.loadDistributors();
  }
};
</script>

<style scoped>
.table th,
.table td {
  white-space: nowrap;
}
.table-responsive-wrapper {
  overflow-x: auto;
  width: 100%;
}
</style>
